module.exports = __webpack_public_path__ + "img/fillfit.64fc9974.jpg";